import React, { useEffect, useState } from "react";
import cn from "classnames";
import style from "../common.module.scss";
import CustomInput from "../../../custom/custom-input/CustomInput";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { toast } from "react-toastify";

const TrackingLink = ({ trackinglink }) => {
  const [trackingLink, setTrackingLink] = useState();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setTrackingLink(trackinglink);
  }, [trackinglink]);

  const handleCopyLink = () => {
    if (!trackingLink) {
      toast.error("Нет ссылки для копирования");
      return;
    }
    navigator.clipboard
      .writeText(trackingLink)
      .then(() => toast.success("Ссылка успешно скопирована!"))
      .catch(() => toast.error("Не удалось скопировать ссылку"));
  };

  const handleOpenLink = () => {
    if (!trackingLink) {
      toast.error("Нет ссылки для перехода");
      return;
    }

    const link = trackingLink.startsWith("http://") || trackingLink.startsWith("https://")
        ? trackingLink
        : `https://${trackingLink}`;

    window.open(link, "_blank");
  };

  return (
    <div className={cn(style.cargo_wrapper)}>
      <div className={cn(style.cargo_title, style.orders_title)}>
        Ссылка для отслеживания
      </div>
      <div style={{ display: "flex", gap: "16px", width: "100%" }}>
        <CustomInput
          value={trackingLink}
          isBgGray
          inputType="text"
          labelText="Трекинг"
          placeholder="Трекинг"
          style={{ flex: "2" }}
        />
        <CustomButton
          text="Скопировать"
          style={{ flex: "1" }}
          onClick={handleCopyLink}
          isLoading={isLoading}
        />
      </div>
      <div style={{ display: "flex", gap: "16px", width: "100%" }}>
        <CustomButton
          text={`Перейти по ссылке: ${trackingLink || "Нет ссылки"}`}
          onClick={handleOpenLink}
          isLoading={isLoading}
          isUnderline
        />
      </div>
    </div>
  );
};

export default TrackingLink;
